var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowDownBold = function SvgArrowDownBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.849 1.776 5 5 5-5",
    stroke: "#000",
    strokeWidth: 2.6
  })));
};
export { SvgArrowDownBold as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDEzIDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+Cgk8cGF0aCBkPSJNMS44NDg2MyAxLjc3NjEyTDYuODQ4NDIgNi43NzYxMkwxMS44NDg0IDEuNzc2MTIiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMi42IiAvPgo8L3N2Zz4=";